<template>
    <div>
        <card-header icon="fa-envelopes-bulk">
            <template #title>
                Communications
            </template>
        </card-header>

        <card-body>
            <card-list>
                <plan-communication-tile
                    :comm="comm"
                    :card="card"
                    v-for="comm in comms"
                    @click="$openCard('view-plan-communication', {planId: props.planId, refId: comm.ref_id, commId: comm.id}, card)"
                    :active="(child && child.definition.component === 'view-plan-communication' && comm.id === parseInt(child.props.commId))"
                />
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import NavigationListItem from "@/TIER/components/NavigationListItem";
    import CardContainer from "@/TIER/components/CardContainer";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";
    import SeparatorListItem from "@/TIER/components/SeparatorListItem";

    import {client as http} from '@/http_client';
    import async from "async";
    import DataRow from "../../TIER/components/DataRow";
    import UserTile from "../../components/tiles/UserTile";
    import TransactionTile from "../../components/tiles/TransactionTile";
    import PlanCommunicationTile from "../../components/tiles/PlanCommunicationTile.vue";

    export default {
        components: {PlanCommunicationTile, TransactionTile, UserTile, DataRow, SeparatorListItem, CardFooter, CardToolbar, CardContainer, NavigationListItem, CardList, CardBody, CardHeader},
        props: ['card', 'props', 'child'],
        data() {
            return {
                comms: []
            };
        },
        methods: {
            loadPlan: function() {
                this.$emit('loading', true);
                async.series([
                    (cb) => {
                        http.get('payment-plans/' + this.props.planId, {force: true}).then(response => {
                            this.comms = response.data.communications;
                            cb();
                        }).catch(err => {
                            cb(err);
                        });
                    }
                ], err => {
                    this.$emit('loading', false);
                });
            }
        },
        mounted() {
            this.loadPlan();
        }
    };
</script>

<style>
    .fa-check {
        color: green;
    }

    .fa-ban {
        color: red;
    }
</style>
